import translate from './translations';

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import './bootstrap';

window.MarkerClusterer = require('@googlemaps/markerclustererplus').default;

window.__ = translate;

require('./components/index');

let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
let sideBarOpening = false;

$(window).resize(function () {
    viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const sidebarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.querySelector(':root').style.setProperty('--sidebar-width', sidebarWidth + 'px');
});

window.cartSidebarToggle = event => {
    /* $('body').toggleClass('body-slide'); */
    sideBarOpening = true;
    // open sidebar
    if (!$('body').hasClass('body-slide-on') && !$('body').hasClass('body-slide-off')) {
        $('body').removeClass('body-slide-off');
        $('body').addClass('body-slide-on');
        $('.backdrop-sidebar').fadeIn();
        sideBarOpening = false;
        // close sidebar
    } else {
        if (!$('body').hasClass('body-slide-off')) {
            $('body').removeClass('body-slide-on');
            $('body').addClass('body-slide-off');
            $('.backdrop-sidebar').fadeOut();
            setTimeout(() => {
                $('body').removeClass('body-slide-off');
                sideBarOpening = false;
            }, 600);
        }
    }
    $('body').removeClass('body-modal-search');
    $('.header-menu').removeClass('menu-show');
    $('.header-menu-wrapper').fadeOut();
    $('.backdrop-menu').fadeOut();
    $('.backdrop-search, .modal-search .modal-inner').fadeOut();

    if (event) event.stopPropagation();
};

(function () {
    'use strict';
    window.addEventListener(
        'load',
        function () {
            var forms = document.getElementsByClassName('needs-validation');

            var validation = Array.prototype.filter.call(forms, function (form) {
                form.addEventListener(
                    'submit',
                    function (event) {
                        if (form.checkValidity() === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        form.classList.add('was-validated');
                    },
                    false
                );
            });
        },
        false
    );
});

$('#loginForm').on('submit', function (e) {
    if ($(this).find('input[name=email]').val() === '' || $(this).find('input[name=password]').val() === '') {
        e.preventDefault();
    }
});

$('#mainPageSearch').on('keydown', function (event) {
    if (event.key == 'Escape') {
        $('body').removeClass('body-modal-search');
        $('.backdrop-search, .modal-search .modal-inner').fadeOut();
    } else if (event.key == 'Enter') {
        $('body').addClass('body-modal-search');
        $('.backdrop-search, .modal-search .modal-inner').fadeIn();
        $('#mainPageSearch').trigger('focus');
    }
});

/* vysunie kosik a vyfejduje backdrop kosika */
$('.cart-sidebar-activator').click(event => {
    window.cartSidebarToggle(event);
    event.stopPropagation();
    closeSortMenu(false);
    closeFilterMenu(false);
});

$('.backdrop-sidebar').click(event => {
    $('body').removeClass('body-slide');
    $('.backdrop').fadeOut();
    if (!sideBarOpening) {
        window.cartSidebarToggle(event);
    }
    event.stopPropagation();
});

$('body').on('click', '.sidebar-close', event => {
    $('body').removeClass('body-slide');
    $('.backdrop').fadeOut();
    if (!sideBarOpening) {
        window.cartSidebarToggle(event);
    }
    event.stopPropagation();
});

/*   window.addEventListener('scroll-sidecart-to-top', event => {
        $('.sidebar-cart-items-wrapper').animate({ scrollTop: 0 }, 'slow');
    }); */

$('.hp_carousel__item')
    .not('.category-show')
    .click(event => {
        if (viewportWidth > 768) {
            $('.hp_carousel__item').removeClass('category-show');
            $(event.target).addClass('category-show');
            $('.hp_carousel').addClass('category-displayed');
            event.stopPropagation();
        }
    });

document.addEventListener('keyup', ({ key }) => {
    if (key === 'Escape') {
        document.body.classList.remove('body-modal-login');
        $('.backdrop-login, .modal-login .modal-inner').fadeOut();
    }
});

/* zobrazi modal login, pri prihlaseni presunie na profil stranku a vyfejduje login backdrop */

$('.login-icon.not-logged, .modal-login .modal-close').click(() => {
    $('body').toggleClass('body-modal-login');
    $('.backdrop-login, .modal-login .modal-inner').fadeToggle();
});

/* pri kliknuti na ktorykolvek backdrop, vypne modal a odfejduje backdrop */

$('.backdrop, .modal').click(event => {
    if ($(event.target).hasClass('shop-modal')) {
        /* if ($('body').hasClass('body-modal-personal')) {
            $('body').removeClass('body-modal-personal');
            $('.modal-personal').css('overflow-y', 'hidden');
        } */

        if ($('body').hasClass('body-modal-terms')) {
            $('body').removeClass('body-modal-terms');
            $('.modal-terms').css('overflow-y', 'hidden');
        }

        if ($('body').hasClass('body-modal-login')) {
            $('body').removeClass('body-modal-login');
        }

        if ($('body').hasClass('body-modal-gift-box')) {
            $('body').removeClass('body-modal-gift-box');
            $('.modal-gift-box').css('overflow-y', 'hidden');
        }

        if ($('body').hasClass('body-modal-delivery')) {
            $('body').removeClass('body-modal-delivery');
            $('.modal-delivery').css('overflow-y', 'hidden');
            $('.backdrop-delivery, .modal-delivery .modal-inner').fadeOut(400, () => {
                $('.payment-type-description').hide();
            });
        }

        /* if ($('header-menu').hasClass('menu-show')) {
            $('.header-menu').removeClass('menu-show');
            $('.header-menu-wrapper').fadeOut();
            $('.backdrop-menu').fadeOut();
        } */

        /* from script beneath was removed classes  .body-modal-personal and  .modal-personal .modal-inner, when upper script was commented */

        $('body').removeClass(
            'body-modal-login body-modal-search  body-modal-terms body-modal-watchdog body-modal-wishlist-email body-modal-gift-box body-modal-wishlist body-modal-size-table body-modal-order-status'
        );
        $(
            '.backdrop, .modal-login .modal-inner, .modal-search .modal-inner, .modal-terms .modal-inner,  .modal-watchdog .modal-inner, modal-wishlist-email .modal-inner, modal-gift-box .modal-inner, .modal-wishlist .modal-inner'
        ).fadeOut();
        if ($('body').hasClass('body-modal-order-storno')) {
            $('body').removeClass('body-modal-order-storno');
            $('.backdrop-order-storno, .modal-order-storno .modal-inner').fadeOut();
            event.stopPropagation();
        }
    }
});

/* po kliknuti na ikonku vyhladavanie togluje zobrazenie modalu, togluje backdrop a vypne header menu */

$('.search-icon').click(() => {
    event.stopPropagation();
    if ($('body').hasClass('body-slide-on')) {
        $('body').removeClass('body-slide-on');
        $('body').addClass('body-slide-off');
        setTimeout(() => {
            $('body').removeClass('body-slide-off');
        }, 600);
    }
    $('body').toggleClass('body-modal-search');

    /*
     * Search modal cannot be closed on a mobile quick fix. However, it does weird stuff
     * when the header search button is clicked multiple times fast.
     * Why were jQuery animations used instead of css transitions?
     */
    $('.backdrop-search, .modal-search .modal-inner').fadeToggle();

    $('.header-menu').removeClass('menu-show');
    $('.header-menu-wrapper').fadeOut();
    $('.backdrop-menu').fadeOut();

    $('.backdrop-sidebar').fadeOut();
    $('#mainPageSearch').trigger('focus');
    closeSortMenu(false);
    closeFilterMenu(false);
});

$(' .modal-watchdog .modal-close').click(() => {
    if ($('body').hasClass('body-modal-watchdog')) {
        $('body').removeClass('body-modal-watchdog');
        $('.backdrop-watchdog, .modal-watchdog .modal-inner').fadeOut();
    } else {
        $('body').addClass('body-modal-watchdog');
        $('.backdrop-watchdog, .modal-watchdog .modal-inner').fadeIn();
    }
    event.stopPropagation();
});

// $(".wishlist-modal-icon, .modal-wishlist .modal-close").click(() => {
//   // if ($('body').hasClass('body-modal-wishlist')) {
//   //     $('body').removeClass('body-modal-wishlist');
//   //     $('.backdrop-wishlist, .modal-wishlist .modal-inner').fadeOut();
//   // } else {
//   $("body").addClass("body-modal-wishlist");
//   $(".backdrop-wishlist, .modal-wishlist .modal-inner").fadeIn();
//   // }
//   event.stopPropagation();
// });

// $('.wishlist-modal-icon, .modal-wishlist .modal-close').click(() => {
//     // if ($('body').hasClass('body-modal-wishlist')) {
//     //     $('body').removeClass('body-modal-wishlist');
//     //     $('.backdrop-wishlist, .modal-wishlist .modal-inner').fadeOut();
//     // } else {
//     $('body').addClass('body-modal-wishlist');
//     $('.backdrop-wishlist, .modal-wishlist .modal-inner').fadeIn();
//     // }
//     event.stopPropagation();
// });

/*   $(".wishlist-email-button, .modal-wishlist-email .modal-close").click(() => {
    if ($("body").hasClass("body-modal-wishlist-email")) {
      $("body").removeClass("body-modal-wishlist-email");
      $(
        ".backdrop-wishlist-email, .modal-wishlist-email .modal-inner"
      ).fadeOut();
    } else {
      $("body").addClass("body-modal-wishlist-email");
      $(
        ".backdrop-wishlist-email, .modal-wishlist-email .modal-inner"
      ).fadeIn();
    }
    event.stopPropagation();
  }); */

/*   $('.gift-box, .modal-gift-box .modal-close, .gift-box-button .shop-button').click(() => {
    if ($("body").hasClass('body-modal-gift-box') ){
      $("body").removeClass("body-modal-gift-box");
      $('.backdrop-gift-box, .modal-gift-box .modal-inner').fadeOut()
    }
    else  {
      $("body").addClass("body-modal-gift-box");
      $('.backdrop-gift-box, .modal-gift-box .modal-inner').fadeIn();
    }
    event.stopPropagation();
  }); */

$('.gift-box, .modal-gift-box .modal-close, .gift-box-button .shop-button').click(event => {
    event.preventDefault();

    if ($('body').hasClass('body-modal-gift-box')) {
        $('body').removeClass('body-modal-gift-box');
        $('.modal-gift-box').css('overflow-y', 'hidden');
        $('.backdrop-gift-box, .modal-gift-box .modal-inner').fadeOut();
    } else {
        $('body').addClass('body-modal-gift-box');
        $('.modal-gift-box').css('overflow-y', 'auto');
        $('.backdrop-gift-box, .modal-gift-box .modal-inner').fadeIn();
    }

    /*  $('.backdrop-gift-box, .modal-gift-box .modal-inner').fadeToggle(function() {
      $("body").removeAttr("style");
      event.stopPropagation();
    });
 */
});

$('.delivery-link, .modal-delivery .modal-close, .delivery-button .shop-button').click(event => {
    event.preventDefault();

    if ($('body').hasClass('body-modal-delivery')) {
        $('body').removeClass('body-modal-delivery');
        $('.modal-delivery').css('overflow-y', 'hidden');
        $('.backdrop-delivery, .modal-delivery .modal-inner').fadeOut(400, () => {
            $('.payment-type-description').hide();
        });
    } else {
        $('body').addClass('body-modal-delivery');
        $('.modal-delivery').css('overflow-y', 'auto');

        if ($(event.target).hasClass('delivery-link')) {
            $('.payment-type-description').show();
            $('#modal-delivery-title-id').html($(event.target).attr('data-title'));
            $('#modal-delivery-description-id').html($(event.target).attr('data-description'));
        }
        $('.backdrop-delivery, .modal-delivery .modal-inner').fadeIn();
    }
});

$('.click-prevent-default').click(event => {
    event.preventDefault();
});

$('header').click(event => {
    if (!$(event.target).hasClass('small-icons')) {
        $('body').removeClass(' body-modal-login body-modal-search body-modal-personal body-modal-terms');
        $('.backdrop-search, .modal-search .modal-inner').fadeOut();
    }
});

$('.personal-data-info, .modal-personal .modal-close').click(event => {
    event.preventDefault();

    if ($('body').hasClass('body-modal-personal')) {
        $('body').removeClass('body-modal-personal');
        $('.modal-personal').css('overflow-y', 'hidden');
    } else {
        $('body').addClass('body-modal-personal');
        $('.modal-personal').css('overflow-y', 'auto');
    }

    $('.backdrop-personal, .modal-personal .modal-inner').fadeToggle(function () {
        $('body').removeAttr('style');
    });
    /*  if ($("body").hasClass('body-modal-personal') ){
    $("body").css("overflow-y", "hidden");
     setTimeout(() => { $("body").removeAttr("style"); }, 300); }
     $('body').toggleClass('body-modal-personal'); */
});

$('.terms-contidions-info, .modal-terms .modal-close').click(event => {
    event.preventDefault();

    if ($('body').hasClass('body-modal-terms')) {
        $('body').removeClass('body-modal-terms');
        $('.modal-personal').css('overflow-y', 'hidden');
    } else {
        $('body').addClass('body-modal-terms');
        $('.modal-terms').css('overflow-y', 'auto');
    }

    $('.backdrop-terms, .modal-terms .modal-inner').fadeToggle(function () {
        $('body').removeAttr('style');
    });
});
if (viewportWidth <= 768) {
    $('#hpCarousel').carousel(0);
}

$('.hp_carousel__headline a').click(event => {
    if (!$(event.target).parent().parent().hasClass('category-show')) {
        const index = $('.hp_carousel__headline').index($(event.target).parent());
        $('#hpCarousel').carousel(index);
        $('#hpCarousel').carousel('pause');
        $('.hp_carousel__item').removeClass('category-show');
        $(event.target).parent().parent().addClass('category-show');
        $('.hp_carousel').addClass('category-displayed');
        event.preventDefault();
    }
    event.stopPropagation();
});

$('.hp_carousel__item')
    .not('.category-show')
    .click(event => {
        if (viewportWidth > 768) {
            $('.hp_carousel__item').removeClass('category-show');
            $(event.target).addClass('category-show');
            $('.hp_carousel').addClass('category-displayed');
            event.stopPropagation();
        }
    });

$('.hp-gant-category-list-wrapper, .hp-gant-category-list-wrapper li, .hp-gant-shops, .hp-gant-shops a').click(event => {
    if (viewportWidth > 768) {
        event.stopPropagation();
    }
});

$('.header-menu-wrapper, .header-menu-wrapper li').click(event => {
    event.stopPropagation();
});

$('.hp-gant-category-return').click(event => {
    $('.hp_carousel__item').removeClass('category-show');
    $('.hp_carousel').removeClass('category-displayed');
    $('#hpCarousel').carousel('cycle');
    event.preventDefault();
    event.stopPropagation();
});

/* V hlavnom menu vyfejduje submenu */

/* Pekne vyfejduje submenu, class menu-show je len na fejdovanie cierneho pozadia okolo gombikov */

$('.js-header-menu-item').on('click', event => {
    if ($(event.target).parent().hasClass('menu-show')) {
        $(event.target).parent().toggleClass('menu-show');
        $('.header-menu-wrapper').fadeOut();
        $('.backdrop-menu').fadeOut();
        $('body').removeClass('body-modal-search');
        $('.backdrop-search, .modal-search .modal-inner').fadeOut();

        $('.backdrop-sidebar').fadeOut();
    } else {
        $('.header-menu').removeClass('menu-show');
        $(event.target).parent().toggleClass('menu-show');
        $('.header-menu-wrapper').fadeOut();
        $(event.target).parent().find('.header-menu-wrapper').fadeIn();
        $('.backdrop-menu').fadeIn();
        $('body').removeClass('body-modal-search');
        $('.backdrop-search, .modal-search .modal-inner').fadeOut();

        $('.backdrop-sidebar').fadeOut();
    }

    if ($('body').hasClass('body-slide-on')) {
        $('body').removeClass('body-slide-on');
        $('body').addClass('body-slide-off');
        setTimeout(() => {
            $('body').removeClass('body-slide-off');
        }, 600);
    }
    event.preventDefault();
    event.stopPropagation();
    closeSortMenu(false);
    closeFilterMenu(false);
});

$('.header-submenu-close, .backdrop-menu').click(event => {
    $('.header-menu').removeClass('menu-show');
    $('.header-menu-wrapper').fadeOut();
    $('.backdrop-menu').fadeOut();
});

const openedOptions = $('.filter-category-title-open .filter-category-options').length;
if (openedOptions) {
    $('.filter-category-title-open .filter-category-options').fadeOut(400, () => {
        $('.filter-category-title-open').removeClass('filter-category-title-open');
    });
}

$('.order-options').fadeOut(400, () => {
    $('.order-wrapper').removeClass('order-wrapper-open');
});

if ($('.filter-wrapper').hasClass('filter-wrapper-open')) {
    $('.filter-categories').fadeOut(400, () => {
        $('.filter-wrapper').removeClass('filter-wrapper-open');
    });
}

/*   $("body").click((e) => {
    var container = $('.order-options');
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        alert ('klikol-som-mimo');
    }}); */

$('.order-title').click(event => {
    let done = false;
    if ($('.filter-wrapper').hasClass('filter-wrapper-open')) {
        $('.filter-wrapper').removeClass('filter-wrapper-open');
        $('.filter-categories').fadeOut(400, () => {
            if (!done) {
                done = true;
                $('.filter-category-title-open .filter-category-options').hide();
                $('.filter-category-title.filter-category-title-open').removeClass('filter-category-title-open');
                $('.order-wrapper').toggleClass('order-wrapper-open');
                $('.order-options').fadeToggle(400);
            }
        });
    } else {
        $('.order-wrapper').toggleClass('order-wrapper-open');
        $('.order-options').fadeToggle(400);
    }
    event.stopPropagation();
});

/* $('order-option').click(event => {
    console.log(event.target);
    if ($('.order-wrapper').hasClass('order-wrapper-open')) {
        $('.order-wrapper').removeClass('order-wrapper-open');
        $('.order-options').fadeOut(400);
    }
}); */

$('body').on('click', '.order-option', event => {
    if ($('.order-wrapper').hasClass('order-wrapper-open')) {
        $('.order-wrapper').removeClass('order-wrapper-open');
        $('.order-options').fadeOut(400);
    }
    event.stopPropagation();
});

$('filter-category-option-close').click(event => {
    const openedOptions = $('.filter-category-title-open .filter-category-options').length;
    if (openedOptions) {
        $('.filter-category-title-open .filter-category-options').fadeOut(400, () => {
            $('.filter-category-title-open').removeClass('filter-category-title-open');
        });
    }
    event.stopPropagation();
});

$('.filter-title').click(event => {
    if ($('.order-wrapper').hasClass('order-wrapper-open')) {
        $('.order-wrapper').removeClass('order-wrapper-open');
        $('.order-options').fadeOut(400, () => {
            $('.filter-wrapper').toggleClass('filter-wrapper-open');
            $('.filter-categories').fadeToggle(400, () => {
                $('.filter-category-title-open .filter-category-options').hide();
                $('.filter-category-title.filter-category-title-open').removeClass('filter-category-title-open');
            });
        });
    } else {
        $('.filter-wrapper').toggleClass('filter-wrapper-open');
        $('.filter-categories').fadeToggle(400, () => {
            $('.filter-category-title-open .filter-category-options').hide();
            $('.filter-category-title.filter-category-title-open').removeClass('filter-category-title-open');
        });
    }
    event.stopPropagation();
});

$('.filter-category-title').click(event => {
    event.stopPropagation();
    let parent;

    if (
        $(event.target).is(':checkbox') ||
        $(event.target).hasClass('filter-category-option-button') ||
        $(event.target).hasClass('filter-category-options-wrapper') ||
        $(event.target).hasClass('filter-category-option') ||
        $(event.target).hasClass('filter-category-option-label') ||
        $(event.target).hasClass('filter-category-value')
    )
        return;
    if ($(event.target).hasClass('filter-category-title')) {
        parent = $(event.target);
    } else if ($(event.target).hasClass('filter-category-title-name-wrapper')) {
        parent = $(event.target).parent();
    } else {
        parent = $(event.target).parent().parent();
    }
    const element = $('.filter-category-options', parent);
    const openedOptions = $('.filter-category-title-open .filter-category-options');
    if (openedOptions.length && !element.is($(openedOptions[0]))) {
        $('.filter-category-title-open .filter-category-options')
            .not(element)
            .fadeOut(200, () => {
                //  $('.filter-category-title-open').not(element).removeClass('filter-category-title-open');
                //  $(parent).toggleClass('filter-category-title-open');
                $('.filter-category-options', parent).fadeToggle(400);
            });
    } else {
        //   $(parent).toggleClass('filter-category-title-open');
        $('.filter-category-options', parent).fadeToggle(400);
    }
});

// $('.discount-checkbox label').click(event => {
//     /* if ($(event.target).hasClass('form-check-input')) { */
//     if (!$('#voucher').prop('checked')) {
//         $('.voucher-input-wrapper').slideDown(200);
//         //  $(".voucher-input-wrapper").addClass('voucher-input-wrapper--open');
//     } else {
//         $('.voucher-input-wrapper').slideUp(200);
//         //  $(".voucher-input-wrapper").removeClass('voucher-input-wrapper--open');
//     }
//     /*    } */
// });

// $('.discount-checkbox label').click(event => {
//     /* if ($(event.target).hasClass('form-check-input')) { */
//     if (!$('#voucher').prop('checked')) {
//         $('.voucher-input-wrapper').slideDown(200);
//         //  $(".voucher-input-wrapper").addClass('voucher-input-wrapper--open');
//     } else {
//         $('.voucher-input-wrapper').slideUp(200);
//         //  $(".voucher-input-wrapper").removeClass('voucher-input-wrapper--open');
//     }
//     /*    } */
// });

$('.cart-personal-details-login-checkbox label').click(event => {
    if (!$('#cart-details-login').prop('checked')) {
        $('.cart-personal-login-wrapper').slideDown(600);
    } else {
        $('.cart-personal-login-wrapper').slideUp(600);
    }
});

$('.cart-personal-details-login-checkbox label').click(event => {
    if (!$('#cart-details-login').prop('checked')) {
        $('.cart-personal-login-wrapper').slideDown(600);
    } else {
        $('.cart-personal-login-wrapper').slideUp(600);
    }
});

$('.cart-personal-details-club-checkbox label').click(event => {
    if (!$('#cart_details_club').prop('checked')) {
        $('.cart-personal-club-wrapper').slideDown(300);
    } else {
        $('.cart-personal-club-wrapper').slideUp(300);
    }
});

$('.cart-personal-details-company-checkbox label').click(event => {
    if (!$('#cart_details_company').prop('checked')) {
        $('.cart-personal-company-wrapper').slideDown(300);
    } else {
        $('.cart-personal-company-wrapper').slideUp(300);
    }
});

$('.cart-personal-details-different-adress-checkbox label').click(event => {
    if (!$('#cart_details_different_adress').prop('checked')) {
        $('.cart-personal-different-adress-wrapper').slideDown(600);
    } else {
        $('.cart-personal-different-adress-wrapper').slideUp(600);
    }
});

$('.cart-personal-details-note-checkbox label').click(event => {
    // console.log(event.target);
    if (!$('#cart-details-note').prop('checked')) {
        $('.cart-personal-note-wrapper').slideDown(300);
    } else {
        $('.cart-personal-note-wrapper').slideUp(300, function () {
            $('.cart-personal-note-wrapper').removeClass('d-block');
        });
    }
});

// toto tu nema co hladat, uplne to nici klik event <--
// $('.payment-method-option').click(() => {
//     $('.payment-method-option').removeClass('payment-method-option-active');
//     $(event.target).closest('.payment-method-option').addClass('payment-method-option-active');
// });
// -->

$('.delivery-link').click(() => {
    event.target;
    event.stopPropagation();
});
/*
    $(window).scroll(function() {
        if ($(window).scrollTop() > 300) {
            $('.scroll-top').addClass('show');
        } else {
            $('.scroll-top').removeClass('show');
        }
    }); */

var scrollTop = 0;
$(window).scroll(function () {
    var curretScrollTop = $(window).scrollTop();
    if (viewportWidth < 768) {
        if (scrollTop > curretScrollTop) {
            $('.scroll-top').addClass('show');
        } else {
            $('.scroll-top').removeClass('show');
        }
    } else {
        if (curretScrollTop > 300) {
            $('.scroll-top').addClass('show');
        } else {
            $('.scroll-top').removeClass('show');
        }
    }
    if (curretScrollTop < 100) {
        $('.scroll-top').removeClass('show');
    }
    scrollTop = curretScrollTop;
});

/*


if (viewportWidth > 768) {
    if ($(window).scrollTop() > 300) {
        $('.scroll-top').addClass('show');
    } else {
        $('.scroll-top').removeClass('show');
    }
}
else {
    'tu pride funkcia'
}
 */

$('#scrollTopButton').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    return false;
});

$('#submit-cart-form').click(function (e) {
    e.preventDefault();
    $('#cart-form').submit();
});

// $('.order-storno, .modal-order-storno .modal-close').click(() => {
//     if ($('body').hasClass('body-modal-order-storno')) {
//         $('body').removeClass('body-modal-order-storno');
//         $('.backdrop-order-storno, .modal-order-storno .modal-inner').fadeOut();
//     } else {
//         $('body').addClass('body-modal-order-storno');
//         $('.backdrop-order-storno, .modal-order-storno .modal-inner').fadeIn();
//     }
//     event.stopPropagation();
// });

$('.modal-order-storno .modal-close').click(() => {
    if ($('body').hasClass('body-modal-order-storno')) {
        $('body').removeClass('body-modal-order-storno');
        $('.backdrop-order-storno, .modal-order-storno .modal-inner').fadeOut();
        event.stopPropagation();
    }
});

/* $('.backdrop, .modal').click(() => {
    if ($('body').hasClass('body-modal-order-storno')) {
        $('body').removeClass('body-modal-order-storno');
        $('.backdrop-order-storno, .modal-order-storno .modal-inner').fadeOut();
        console.log('dole');
        event.stopPropagation();
    }
}); */

$('.order-status-info-modal, .modal-order-status .modal-close').click(() => {
    if ($('body').hasClass('body-modal-order-status')) {
        $('body').removeClass('body-modal-order-status');
        $('.backdrop-order-status, .modal-order-status .modal-inner').fadeOut();
        console.log('vypis');
    } else {
        $('body').addClass('body-modal-order-status');
        $('.backdrop-order-status, .modal-order-status .modal-inner').fadeIn();
    }
    event.stopPropagation();
});

function closeSortMenu(animate = true) {
    if (animate) {
        $('.order-options').fadeOut(400, () => {
            $('.order-wrapper').removeClass('order-wrapper-open');
        });
    } else {
        $('.order-wrapper').removeClass('order-wrapper-open');
        $('.order-options').hide();
    }
}

function closeFilterMenu(animate = true) {
    var openedOptions = $('.filter-category-title-open .filter-category-options').length;
    if (openedOptions) {
        if (animate) {
            $('.filter-category-title-open .filter-category-options').fadeOut(400, () => {
                $('.filter-category-title-open').removeClass('filter-category-title-open');
            });
        } else {
            $('.filter-category-title-open .filter-category-options').hide();
            $('.filter-category-title-open').removeClass('filter-category-title-open');
        }
    }
}

/*    $('.order-history-card-basic-info-wrapper').click(event => {
        $(event.target).parent().toggleClass('expanded');
    }); */

var OrderBoxItem = function (rootEl) {
    var _self = this;
    var clicker = null;
    var divToOpen = null;
    var divToOpenStatus = null;
    var openClassName = 'expanded';

    var onclick = function () {
        if (divToOpenStatus !== true) {
            rootEl.addClass(openClassName);
            divToOpenStatus = true;
        } else {
            rootEl.removeClass(openClassName);
            divToOpenStatus = false;
        }
    };

    var init = function () {
        clicker = rootEl.find('.order-history-card-basic-info-wrapper');
        divToOpen = rootEl.find('.order-history-details-wrapper');
        clicker.click(function () {
            onclick();
        });
    };

    init();
};

var OrderBox = function () {
    var items = $('.order-history-card-inner');
    items.each(function (i, el) {
        new OrderBoxItem($(el));
    });
};

new OrderBox();
function getMainMenuBottomEdgePosition() {
    var el = $('#top-wrapper-selector');
    if (Object.keys(el).length !== 0) {
        return el.offset().top + el.height();
    }
}

$(window).resize(function () {
    setMobileSidecartPosition();
});

$(window).resize(function () {
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth > 768) {
        $('.modal-search-top-selector').offset({ top: 50 });
    } else {
        var pos = getMainMenuBottomEdgePosition();
        $('.modal-search-top-selector').offset({ top: pos });
        if ($('.filter-wrapper').hasClass('filter-wrapper-open')) {
            // $('.active-filters-wrapper').show();
        }
    }
});

function setMobileSidecartPosition() {
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth < 768) {
        var pos = getMainMenuBottomEdgePosition();
        $('.modal-top-selector').offset({ top: pos });
    }
}

$(window).trigger('resize');
window.setMobileSidecartPosition = setMobileSidecartPosition;

window.addEventListener('load', event => {
    checkTopMenuBanner();
});

function checkTopMenuBanner() {
    if ($('.index-top-banner').length) {
        $('body').addClass('body-index-top-banner');
    }
}

/* Nasledujuca funkcia vytvori poziciovanie submenu  na zaklade vysky elementu "#top-wrapper-selector", staci vedla .header-menu-wrapper pridat .mobile-menu-top-selector a cele submenu vsade aj pre gant
aj vermont bude poziciovane automaticky inlineovo.  */

/* window.addEventListener('load', event => {
    setMobileMenuTopPosition();
});

window.addEventListener('resize', event => {
    setMobileMenuTopPosition();
});

function getMainMenuBottomEdgePositionNew() {
    var el = $('#top-wrapper-selector');
    if (Object.keys(el).length !== 0) {
        return +el.height();
    }
}

function setMobileMenuTopPosition() {
    var pos = getMainMenuBottomEdgePositionNew();
    $('.mobile-menu-top-selector').css({ top: pos });
} */

$('#static-page-image-scroll').click(function () {
    $([document.documentElement, document.body]).animate(
        {
            scrollTop: $('#wysiwyg-anchor').offset().top,
        },
        600
    );
});

$('body').on('click', '#login-button', e => {
    e.preventDefault();
    $('#login-button').prop('disabled', true);
    $('#loginForm').submit();
});

$('body').on('click', '#modal-login-button-cart', e => {
    e.preventDefault();
    $('#modal-login-button-cart').prop('disabled', true);
    $('#loginFormCart').submit();
});

$('body').on('click', '#logout-button', e => {
    e.preventDefault();
    $('#logout-button').prop('disabled', true);
    $('#logoutForm').submit();
});

if (/Edge?/.test(navigator.userAgent)) {
    $('body').addClass('browser-edge');
}

const isChrome = /Chrome/.test(navigator.userAgent);

if (!isChrome && /Safari/.test(navigator.userAgent)) {
    $('body').addClass('browser-safari');
}

$('product-detail-many-sizes').fadeOut(400, () => {
    $('.product-many-sizes-wrapper').removeClass('many-sizes-open');
});

$('.product-detail-many-sizes-title').click(event => {
    $('.product-detail-many-sizes-wrapper').toggleClass('many-sizes-open');
    $('.product-detail-many-sizes').fadeToggle(400);
});

$('body').on('click', '.delayed-link, .modal-delayed .modal-close, .backdrop-delayed', event => {
    console.log('sme tu');
    if ($('body').hasClass('body-modal-delayed')) {
        $('body').removeClass('body-modal-delayed');
        /*   $('.modal-delayed').css('overflow-y', 'hidden'); */
        $('.backdrop-delayed, .modal-delayed .modal-inner').fadeOut(100);
    } else {
        $('body').addClass('body-modal-delayed');
        /*    $('.modal-delayed').css('overflow-y', 'auto'); */
        $('.backdrop-delayed, .modal-delayed .modal-inner').fadeIn(100);
        $('#modal-delivery-title-id').html($(event.target).attr('data-title'));
        $('#modal-delivery-description-id').html($(event.target).attr('data-description'));
    }
    event.stopPropagation();
});

$('body').on('click', '.backdrop-delayed', event => {
    if ($('body').hasClass('body-modal-delayed')) {
        $('body').removeClass('body-modal-delayed');
        $('.backdrop-delayed, .modal-delayed .modal-inner').fadeOut(100);
    }
    event.stopPropagation();
});

$('.js-shop-the-look-actual-product').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    return false;
});

$('body').on('click', '.js-subcategories-top-description-button', event => {
    $('html, body').animate({ scrollTop: $('.js-subcategories-bottom-description').offset().top }, 'slow');
    event.stopPropagation();
});

import Alpine from 'alpinejs';
import mask from '@alpinejs/mask';
Alpine.plugin(mask);
window.Alpine = Alpine;
Alpine.start();

/* (function () {
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth < 960) {
        var pos = getMainMenuBottomEdgePosition();
        $('.mobile-menu-top-selector').offset({ top: pos });
    }
}); */

/* $(window).resize(function () {
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    if (viewportWidth > 960) {
        $('.header-menu-wrapper.mobile-menu-top-selector').offset({ top: 126 });
    } else {
        var pos = getMainMenuBottomEdgePosition();
        $('.header-menu-wrapper.mobile-menu-top-selector').offset({ top: pos });
    }
});
 */
/* function setMobileSidecartPosition() {
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth < 768) {
        var pos = getMainMenuBottomEdgePosition();
        $('.modal-top-selector').offset({ top: pos });
    } else {
        $('.modal-top-selector').offset({ top: 0 });
    }
} */

$('body').on('change', '.js-floating-label-on-change', function () {
    if ($(this).val().length > 0) {
        if (!$(this).hasClass('hasvalue')) {
            $(this).addClass('hasvalue');
        }
    } else {
        $(this).removeClass('hasvalue');
    }
});
